import { useTheme } from '@material-ui/core/styles'

interface IStatus {
  [key: string]: {
    text: string,
    color: string
  }
}

const useDeadlineStatus = () : IStatus => {
  const theme = useTheme()

  return {
    ON_TIME: { text: 'No prazo', color: theme.palette.success.dark },
    LATE: { text: 'Atrasada', color: theme.palette.error.dark }
  }
}

export default useDeadlineStatus
